//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCreditCauses', {
//        templateUrl: 'views/components/views/orderLineCreditCauses/orderLineCreditCauses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'orderLineCreditCausesService', function (stateService, orderLineCreditCausesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCauses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadOrderLineCreditCauses() {
//                vm.model.itemsListCauses = await orderLineCreditCausesService.listOrderLineCreditCauses();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'orderlinecreditcause':
//                        go({ orderlinecreditcause_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadOrderLineCreditCauses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
